module.exports = __webpack_public_path__ + "img/slider1.c66d007d.png";